module.exports = __webpack_public_path__ + "static/email/img/user.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.png
// module id = AGL3
// module chunks = 1